export const i18nDatetimeFormats = {
  date: {
    lts: 'MM/DD/YYYY',
    dateTime: 'MM/YYYY HH:mm',
    datetime_minute: 'MM/DD HH:mm',
    datetime_minute_second: 'MM/DD/YYYY HH:mm:ss',
    datetime_second: 'DD MMM HH:mm:ss',
    day_month: 'MM/DD',
    month_year: 'MM/YYYY',
  },
  units: {
    'kilo pascal hora per': 'kPa/hr',
    'revolution per minut': 'RPM',
    'kilogram per cubic m': 'kg/m³',
    volt: 'V',
    kilopascal: 'kPa',
    'kilopascal gauge': 'kPag',
    liter: 'L',
    'Kg/h': 'kg/h',
    'Inches Of Water Colu': 'inH₂O',
    pascal: 'Pa',
    'std cubic meter per ': 'Sm³/h',
    'tons per hour': 'tph',
    ampere: 'A',
    hertz: 'Hz',
    barg: 'barg',
    mils: 'mil',
    tonne: 't',
    'cubic meter per hour': 'm³/h',
    'cubic meter per hour 10^-2': 'm³/h 10⁻²',
    millimeter: 'mm',
    MVA: 'MVA',
    'Milligram per liter': 'mg/L',
    'kilojoule per kilogr': 'kJ/kg',
    percent: '%',
    'normal cubic meter p': 'Nm³/h',
    'standard cubic meter': 'Sm³',
    'cubic meter': 'm³',
    'Liter per hour squar': 'L/(h·m²)',
    'liter per hour': 'L/h',
    'parts per million': 'ppm',
    kilowatt: 'kW',
    day: 'd',
    'kg CO2e/boe': 'kg CO₂e/boe',
    Millivolt: 'mV',
    MVAR: 'MVAR',
    'differential pound-f': 'lbf',
    'minute-1': 'min⁻¹',
    'milimeter per second': 'mm/s',
    'pound-force per squa': 'psi',
    'revolution per minute': 'RPM',
    KV: 'kV',
    hour: 'hr',
    'micrometer pp': 'µm',
    MW: 'MW',
    Fahrenheit: '°F',
    'degree Celsius': '°C',
    'parts per billion': 'ppb',
    'barrel per day': 'bbl/d',
    ohm: 'Ω',
  },
};
